module.exports = __webpack_public_path__ + "static/img/42001.59cdc42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/42001.jpg
// module id = zd6G
// module chunks = 1